<template>
  <div class="finder" :style="{height: height + 'px'}" ref="finderDom">
    <div class="finder-inner">
      <finderframe
        v-for="(frame, index) in frames"
        v-on:click="childClicked"
        :class="frameClasses"
        :index="index"
        :label="frame.label"
        :children="frame.children"
        :active-child="frame.activeChild"
        :is-last="index + 1 == frames.length"
        :height="height"
      ></finderframe>
    </div>
  </div>
</template>
<script>
import FinderFrame from './FinderFrame.vue';

export default {
  components: {
    finderframe: FinderFrame
  },
  props: {
    tree: {
      type: Object
    },
    selection: {
      type: Array,
      default() {
        return [];
      }
    },
    framesTest: {
      type: Array,
      default() {
        return [];
      }
    },
    height: {
      type: Number,
      default: 400
    },
    frameClasses: {}
  },
  computed: {
    frames() {
      var frames = [ this.tree ],
          branch = this.tree;

      for (var i = 0 ; i < this.selection.length ; i++) {
        branch.activeChild = this.selection[i];
        branch = branch.children[this.selection[i]];
        if (typeof branch.children == 'object') {
          branch.activeChild = null;
          frames.push(branch);
        }
      }

      return frames;
    }
  },
  methods: {
    childClicked(child, index, key) {
      this.$emit('clickchild', child, index, key, this.addSelection);

      this.$refs.finderDom.scrollTop = 0;
    },
    addSelection(ref, index, key) {
      ref.selection.splice(index);
      ref.selection.push(key);
    }
  }
};
</script>
